import { render, staticRenderFns } from "./IconPublish.vue?vue&type=template&id=3d34ac10&scoped=true"
import script from "./IconPublish.vue?vue&type=script&lang=js"
export * from "./IconPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34ac10",
  null
  
)

export default component.exports